import React from 'react';
import { FaPhone } from 'react-icons/fa';
import './CallButton.css';

const CallButton = () => {
  const phoneNumber = '7200085345'; // Replace with your phone number
  
  const handleCallClick = () => {
    const callUrl = `tel:${phoneNumber}`;
    // For mobile devices, this will open the native dialer
    // For desktop, it will attempt to open the default phone app
    window.location.href = callUrl;
  };

  return (
    <div className="call-button" onClick={handleCallClick}>
      <FaPhone className="call-icon" />
      <span className="call-tooltip">Call us now</span>
    </div>
  );
};

export default CallButton;